import { render, staticRenderFns } from "./ProjectIntro.vue?vue&type=template&id=29c918a5&scoped=true"
import script from "./ProjectIntro.vue?vue&type=script&lang=js"
export * from "./ProjectIntro.vue?vue&type=script&lang=js"
import style0 from "./ProjectIntro.vue?vue&type=style&index=0&id=29c918a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c918a5",
  null
  
)

export default component.exports